import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthenticatedLayout = ({ onLogout }) => {
  // AppBanner is already rendered in App.js, so we don't need it here
  // The refetchUsage context is handled via the refreshUsage event
  return (
      <div style={{ paddingTop: '72px' }}>
      <Outlet context={{ refetchUsage: () => window.dispatchEvent(new Event('refreshUsage')) }} />
      </div>
  );
};

export default AuthenticatedLayout; 